import { cn } from '@/lib/utils';
import type { FAQProps, FAQ as FAQType } from '@/types';

/**
 * FAQ Section Component
 * Displays frequently asked questions in a clean grid layout
 */
export function FAQ({ faqs, className }: FAQProps) {
  return (
    <section className={cn("py-20", className)}>
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold">
            Frequently Asked Questions
          </h2>
        </div>
        
        {/* FAQ Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <FAQItem key={index} faq={faq} />
          ))}
        </div>
      </div>
    </section>
  );
}

/**
 * Individual FAQ Item Component
 */
interface FAQItemProps {
  faq: FAQType;
}

function FAQItem({ faq }: FAQItemProps) {
  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold">
        {faq.question}
      </h3>
      <p className="text-muted-foreground">
        {faq.answer}
      </p>
    </div>
  );
}
